// Speil av functions/personnelStateAccess.ts — delingen av personaldata.
//
// Lonn, ansattdata og lonnsslipper la i `businesses/{id}/app/state`, samme dokument
// som fakturaene. Firestore-regler avgjor tilgang per dokument, ikke per felt, sa
// `viewer` — rollen invitasjonsdialogen kaller «lesetilgang» — kunne lese hva hver
// ansatt tjener.
//
// Personalfeltene bor derfor i `businesses/{id}/personnel/state`, som viewer ikke har
// leserett til. Delingen skjer bare ved lagring og lasting: over det laget ser
// sidene i src/ ett samlet `appState`, akkurat som for.
//
// FELTLISTEN MAA HOLDES I SYNK med functions/personnelStateAccess.ts. Et nytt
// personalfelt som ikke star her havner i app/state og blir lesbart for viewer.
// scripts/check-personnel-state-mirror.mjs sjekker at listene er like.

(function () {
  const PERSONNEL_STATE_FIELDS = [
    'employees',
    'payrollRuns',
    'aMeldingSubmissions',
    'payrollTaxPaymentsByYear',
    'payrollSettings',
    'payrollFixedLines',
    'employeePortalTravels',
  ];

  const isPlainObject = (value) => Boolean(value) && typeof value === 'object' && !Array.isArray(value);

  const stripPersonnelState = (state) => {
    if (!isPlainObject(state)) return state;
    const result = { ...state };
    for (const field of PERSONNEL_STATE_FIELDS) {
      if (field in result) delete result[field];
    }
    return result;
  };

  // Felt som ikke finnes tas ikke med: ellers ville en delvis lagring skrevet
  // undefined over ekte data.
  const pickPersonnelState = (state) => {
    if (!isPlainObject(state)) return {};
    const result = {};
    for (const field of PERSONNEL_STATE_FIELDS) {
      if (field in state) result[field] = state[field];
    }
    return result;
  };

  const splitPersonnelState = (state) => ({
    appState: stripPersonnelState(state),
    personnelState: pickPersonnelState(state),
  });

  // Personaldelen vinner. Rester i app/state fra for migreringen skal ikke
  // overstyre den autoritative kilden.
  const mergePersonnelState = (appState, personnelState) => {
    const base = isPlainObject(appState) ? appState : {};
    const personnel = isPlainObject(personnelState) ? personnelState : {};
    const result = { ...base };
    for (const field of PERSONNEL_STATE_FIELDS) {
      if (field in personnel) result[field] = personnel[field];
    }
    return result;
  };

  const hasPersonnelStateFields = (state) =>
    Boolean(isPlainObject(state) && PERSONNEL_STATE_FIELDS.some((field) => field in state));

  window.PlummePersonnelState = {
    PERSONNEL_STATE_FIELDS,
    stripPersonnelState,
    pickPersonnelState,
    splitPersonnelState,
    mergePersonnelState,
    hasPersonnelStateFields,
  };
})();
